import { HttpContextToken } from '@angular/common/http';
import { Signal } from '@angular/core';

/**
 * Метка «этот запрос — служебная проба доступности».
 * ConnectivityInterceptor такие запросы игнорирует, иначе проба сама себя зациклит.
 */
export const SKIP_CONNECTIVITY_TRACKING = new HttpContextToken<boolean>(() => false);

/**
 * online  — связь есть;
 * suspect — есть подозрение на обрыв, идут пробы, пользователю ничего не показываем;
 * offline — обрыв подтверждён несколькими пробами подряд, показываем блокирующую модалку.
 */
export type ConnectivityStatus = 'online' | 'suspect' | 'offline';

/**
 * Публичный контракт ConnectivityService для модалки.
 * Вынесен в отдельный файл, чтобы не было циклического импорта service ↔ modal:
 * сервис импортирует компонент модалки, а модалка получает сервис через NZ_MODAL_DATA.
 */
export interface ConnectivityView {
  readonly attempt$: Signal<number>;
  readonly nextProbeInSec$: Signal<number>;
  probeNow(): void;
}
